import request from '@/utils/request';


// 提交订单
export function orderSubmit(data) {
  return request({
    url: '/wx/order/submit',
    method: 'POST',
    data: data,
  })
}

// 评价
export function comment(data) {
  return request({
    url: '/wx/order/comment',
    method: 'POST',
    data: data,
  })
}

// 取消订单
export function cancel(data) {
  return request({
    url: '/wx/order/cancel',
    method: 'POST',
    data: data,
  })
}

// 订单列表
export function orderList(query) {
  return request({
    url: '/wx/order/list',
    method: 'get',
    params: query
  })
}

// 订单详情
export function orderDetail(id) {
  return request({
    url: '/wx/order/detail?orderId=' + id,
    method: 'get',
  })
}

//定制订单下单
export function addCustomize(data) {
  return request({
    url: '/wx/customize/addCustomize',
    method: 'POST',
    data: data,
  })
}

//图片上传
export function uploadFile(data) {
  let config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }
  return request({
    url: '/wx/storage/upload',
    method: 'POST',
    data: data,
    headers: config,
  })
}

/**
 *  销售类型
 * @returns
 */
export function scaletype() {
  return request({
    url: '/wx/erp/scaletype/list',
    method: 'GET',
  });
}

/**
 *  发运方式
 * @returns
 */
export function shippingchoice() {
  return request({
    url: '/wx/erp/shippingchoice/list',
    method: 'GET',
  });
}

/**
 *  发货方式
 * @returns
 */
export function getDicListByCid(data) {
  return request({
    url: '/wx/erp/erpDictionary/listByCid',
    method: 'POST',
    data: data,
  });
}

/**
 *  选择客户
 * @param name
 * @returns
 */
export function getCustomer(name) {
  return request({
    url: '/wx/enterprise/list?name=' + name,
    method: 'get',
  });
}
//确认收货
export function confirmReceive(data){
  return request({
    url: '/wx/order/confirm',
    method: 'post',
    data,
  });
}

// ERP订单列表
export function erpOrderList(query) {
  return request({
    url: '/wx/erpSaleOrder/list',
    method: 'get',
    params: query,
  })
}
//ERP订单详情
export function getErpOrderDetail(orderSn) {
  return request({
    url: '/wx/erpSaleOrder/erpOrderDetail?orderSn=' + orderSn,
    method: 'get',
  });
}

export function getExpressList(data) {
  return request({
    url: '/wx/order/expressTraceShipSnList',
    method: 'get',
    params: data
  });
}

export function getExpressDetail(data) {
  return request({
    url: '/wx/order/expressTrace',
    method: 'get',
    params: data,
  });
}



// WEBPACK FOOTER //
// ./src/api/order/order.js